import type { FC } from "react";

import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

import { NoData } from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";
import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 33px;
`;

interface INoSegments {
    onClick?: VoidFunction;
}

const onBuildSegment = () => {
    proNavigator.go("digitalsuite_segments-wizard");
};

export const NoSegments: FC<INoSegments> = (props) => {
    const { onClick = onBuildSegment } = props;

    return (
        <>
            <NoData
                noDataTitleKey={"competitive.tracker.autocomplete.no.segments.title"}
                noDataSubTitleKey={"competitive.tracker.autocomplete.no.segments.content"}
                paddingBottom={"15px"}
                paddingTop={"40px"}
            />
            <ButtonContainer>
                <Button onClick={onClick}>{translate("competitive.tracker.autocomplete.no.segments.create")}</Button>
            </ButtonContainer>
        </>
    );
};
